import { Editor, Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';
import type { EditorView } from '@tiptap/pm/view';

class TableMenuView {
  private editor: Editor;
  private menu: HTMLDivElement;

  constructor({ editor, view }: { editor: Editor; view: EditorView }) {
    this.editor = editor;

    this.menu = document.createElement('div');
    this.menu.className = 'block-menu';
    this.menu.style.display = 'none';

    const items = [
      [
        {
          title: '设置/取消表头',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17 11V4H19V21H17V13H7V21H5V4H7V11H17Z"></path></svg>',
          command: () => {
            editor.chain().focus().toggleHeaderCell().run();
          },
        },
      ],
      [
        {
          title: '在前面添加一行',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13H20ZM19 15H5V19H19V15ZM12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1ZM13 3H11V4.999L9 5V7L11 6.999V9H13V6.999L15 7V5L13 4.999V3Z"></path></svg>',
          command: () => {
            editor.chain().focus().addRowBefore().run();
          },
        },
        {
          title: '在后面添加一行',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 13C14.7614 13 17 15.2386 17 18C17 20.7614 14.7614 23 12 23C9.23858 23 7 20.7614 7 18C7 15.2386 9.23858 13 12 13ZM13 15H11V16.999L9 17V19L11 18.999V21H13V18.999L15 19V17L13 16.999V15ZM20 3C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4C3 3.44772 3.44772 3 4 3H20ZM5 5V9H19V5H5Z"></path></svg>',
          command: () => {
            editor.chain().focus().addRowAfter().run();
          },
        },
        {
          title: '删除整行',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 5C20.5523 5 21 5.44772 21 6V12C21 12.5523 20.5523 13 20 13C20.628 13.8355 21 14.8743 21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16C11 14.8743 11.372 13.8355 11.9998 12.9998L4 13C3.44772 13 3 12.5523 3 12V6C3 5.44772 3.44772 5 4 5H20ZM13 15V17H19V15H13ZM19 7H5V11H19V7Z"></path></svg>',
          command: () => {
            editor.chain().focus().deleteRow().run();
          },
        },
      ],
      [
        {
          title: '在前面添加一列',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H14C13.4477 21 13 20.5523 13 20V4C13 3.44772 13.4477 3 14 3H20ZM19 5H15V19H19V5ZM6 7C8.76142 7 11 9.23858 11 12C11 14.7614 8.76142 17 6 17C3.23858 17 1 14.7614 1 12C1 9.23858 3.23858 7 6 7ZM7 9H5V10.999L3 11V13L5 12.999V15H7V12.999L9 13V11L7 10.999V9Z"></path></svg>',
          command: () => {
            editor.chain().focus().addColumnBefore().run();
          },
        },
        {
          title: '在后面添加一列',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 3C10.5523 3 11 3.44772 11 4V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM9 5H5V19H9V5ZM18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 9.23858 15.2386 7 18 7ZM19 9H17V10.999L15 11V13L17 12.999V15H19V12.999L21 13V11L19 10.999V9Z"></path></svg>',
          command: () => {
            editor.chain().focus().addColumnAfter().run();
          },
        },
        {
          title: '删除整列',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 3C12.5523 3 13 3.44772 13 4L12.9998 11.9998C13.8355 11.372 14.8743 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C14.9681 21 14.0092 20.6874 13.2129 20.1518L13 20C13 20.5523 12.5523 21 12 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H12ZM11 5H7V19H11V5ZM19 15H13V17H19V15Z"></path></svg>',
          command: () => {
            editor.chain().focus().deleteColumn().run();
          },
        },
      ],
      [
        {
          title: '删除表格',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"></path></svg>',
          command: () => {
            editor.chain().focus().deleteTable().run();
          },
        },
      ],
    ];

    items.forEach((group) => {
      const div = document.createElement('div');
      div.className = 'block-menu-group';
      this.menu.appendChild(div);

      group.forEach(({ icon, command, title }) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'block-menu-item';
        button.dataset.tippyContent = title;
        button.innerHTML = icon;
        button.setAttribute('title', title);
        button.addEventListener('click', command);
        div.appendChild(button);
      });
    });

    view.dom.parentNode.appendChild(this.menu);

    this.update(view, null);
  }

  update(view: EditorView, lastState: any) {
    let { state } = view;

    // Don't do anything if the document/selection didn't change
    if (lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
      return;
    }

    // Find the parent table node
    let table = null;
    let tablePos = null;
    for (let i = state.selection.$from.depth; i > 0; i--) {
      if (state.selection.$from.node(i).type.spec.tableRole === 'table') {
        table = state.selection.$from.node(i);
        tablePos = state.selection.$from.before(i);
        break;
      }
    }

    if (table === null) {
      this.menu.style.display = 'none';
      return;
    }

    this.menu.style.display = 'flex';

    const coords = view.coordsAtPos(tablePos);

    const box = this.menu.offsetParent.getBoundingClientRect();

    // update menu bottom
    this.menu.style.bottom = `${box.bottom - coords.top + 8}px`;
  }

  destroy() {
    this.menu.remove();
  }
}

const TableMenu = Extension.create({
  name: 'tableMenu',

  addProseMirrorPlugins() {
    const editor = this.editor;
    return [
      new Plugin({
        view(editorView) {
          return new TableMenuView({ editor, view: editorView });
        },
      }),
    ];
  },
});

export default TableMenu;
